/* eslint-disable object-shorthand */
import { css } from 'styled-components'

export const sizes = {
  fullHd: 1920,
  giant: 1200,
  desktop: 992,
  tablet: 768,
  largePhone: 480,
  phone: 376
}

export const mediaBigger = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16
  accumulator[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})
// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16
  accumulator[label] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)};
    }
  `
  return accumulator
}, {})

export const pageview = (url) => {
  if (window && window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: url
    })
  }
}

// export const event = (eventName, category, action, label) => {
//   try {
//     if (window?.dataLayer) {
//       window.dataLayer.push({
//         event: "eventTracking",
//         category: category,
//         action: action,
//         label: label,
//       });
//       window.dataLayer.push({
//         event: eventName,
//         category: category,
//         action: action,
//         label: label,
//       });
//     }
//   } catch (error) {
//     console.log("Analytics Event Error");
//   }
// };



// WEBPACK FOOTER //
// ./src/utils.js